module.exports = __webpack_public_path__ + "img/LCD_Display.5e64003b.jpg";